import { useState } from "react";
import ButtonWithIcon from "src/SharedComponents/ButtonWithIcon/ButtonWithIcon";
import AddDemoTrialLicense from "../AddDemoTrialLicense/AddDemoTrialLicense";
import { useGetPartnersClinicInfo } from "src/Utils/Hooks/GetPartnersInfo/GetPartnersClinics/useGetPartnersClinicsInfo";
import { useSupportPermissions } from "src/Utils/Hooks/useGetAdminInfo/useSupportPermissions";

interface IDemoTrialLicense {
    updateLicenses: () => void;
}

const DemoTrialLicense: React.FC<IDemoTrialLicense> = ({updateLicenses}) => {
    const {data} = useGetPartnersClinicInfo();
    const [showNewLicenseDialog, setShowNewLicenseDialog] = useState<boolean>(false);
    const { isSupportAdmin } = useSupportPermissions();
    
    return(
        <>
            {
                showNewLicenseDialog && data &&
                <AddDemoTrialLicense
                    partnerClinics={data}
                    onCloseAddDialog={() => setShowNewLicenseDialog(false)}
                    updateLicenses={updateLicenses}
                />
            }
            <ButtonWithIcon
                onClick={() => { setShowNewLicenseDialog(true); }}
                label="Add Demo/Trial"
                icon='bi bi-plus-lg'
                testId='addLicense'
                disable={!isSupportAdmin}
            />
        </>
    );
}

export default DemoTrialLicense;